// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ILetterCommunicationDestination
 */
export interface ILetterCommunicationDestination {
    /**
     * 
     * @type {string}
     * @memberof ILetterCommunicationDestination
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ILetterCommunicationDestination
     */
    sent_to?: string;
    /**
     * 
     * @type {string}
     * @memberof ILetterCommunicationDestination
     */
    address_line1?: string;
    /**
     * 
     * @type {string}
     * @memberof ILetterCommunicationDestination
     */
    address_line2?: string;
    /**
     * 
     * @type {string}
     * @memberof ILetterCommunicationDestination
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ILetterCommunicationDestination
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof ILetterCommunicationDestination
     */
    zip_code?: string;
}

/**
 * Check if a given object implements the ILetterCommunicationDestination interface.
 */
export function instanceOfILetterCommunicationDestination(value: object): value is ILetterCommunicationDestination {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ILetterCommunicationDestinationFromJSON(json: any): ILetterCommunicationDestination {
    return ILetterCommunicationDestinationFromJSONTyped(json, false);
}

export function ILetterCommunicationDestinationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILetterCommunicationDestination {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'sent_to': json['sent_to'] == null ? undefined : json['sent_to'],
        'address_line1': json['address_line1'] == null ? undefined : json['address_line1'],
        'address_line2': json['address_line2'] == null ? undefined : json['address_line2'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zip_code': json['zip_code'] == null ? undefined : json['zip_code'],
    };
}

export function ILetterCommunicationDestinationToJSON(json: any): ILetterCommunicationDestination {
    return ILetterCommunicationDestinationToJSONTyped(json, false);
}

export function ILetterCommunicationDestinationToJSONTyped(value?: ILetterCommunicationDestination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'sent_to': value['sent_to'],
        'address_line1': value['address_line1'],
        'address_line2': value['address_line2'],
        'city': value['city'],
        'state': value['state'],
        'zip_code': value['zip_code'],
    };
}

